import {
  DEFAULT_BATCH_SIZE,
  TaskQueue,
} from 'packages/task-man/service/pickup/task-queue';
import useSWRImmutable from 'swr/immutable';
import { multitaskBatchIDAtom } from 'packages/at-shell/state/recoil/ui';
import { useRecoilValue } from 'recoil';
import { swrKey } from 'packages/task-man/service/pickup/use-task-queue';

/** Important: for returned mutateAssignedTasks() to work, you MUST pass in a valid taskQueue. This tends to not work so well.
 * Instead: to trigger a load of the next batch of tasks, increment multitaskBatchIDAtom. This is used to invalidate
 * useSWR's cache and trigger a reload.
 */
export const useAssignedTasks = (
  taskQueue?: TaskQueue,
  n = DEFAULT_BATCH_SIZE
) => {
  const multitaskBatchID = useRecoilValue(multitaskBatchIDAtom);
  const {
    data: assignedTasks,
    error: assignedTasksError,
    isLoading: isLoadingAssignedTasks,
    mutate,
  } = useSWRImmutable(
    taskQueue
      ? swrKey(taskQueue, multitaskBatchID, `assigned-tasks/${n}`)
      : null,
    () => taskQueue?.getManyAssignedTasks(n)
  );

  return {
    assignedTasks,
    assignedTasksError,
    isLoadingAssignedTasks,
    mutateAssignedTasks: mutate,
  };
};
